/* JS AI Search part 5: storefront settings, catalogue loading, live checks, AI call, anonymous log. Loaded in order with the other js-ai-*.js files (see snippets/js-ai-search-boot.liquid).
   Overview and switches: see the header of js-ai-1-nlp.js. */
(function (root) {
  'use strict';
  var X = root.JSAIX = root.JSAIX || {};
  var POUND = X.POUND, cleanText = X.cleanText, Engine = X.Engine, applyLive = X.applyLive;
  // ================================================================== UI (browser only)
  var cfg = root.JSAI;
  if (!cfg || cfg.enabled === false || typeof document === 'undefined' || root.__JSAI_STARTED) return;
  try { if (/[?&]jsai=off\b/.test(location.search)) sessionStorage.setItem('jsai-off', '1'); if (/[?&]jsai=on\b/.test(location.search)) sessionStorage.removeItem('jsai-off'); if (sessionStorage.getItem('jsai-off')) return; } catch (e) { /* storage unavailable: carry on */ }

  var copy = {
    placeholder: 'AI SHOPPER: what can I buy under £15 / banana / strawberry',
    placeholderShort: 'AI SHOPPER: under £15 / banana / strawberry',
    loading: 'Looking…',
    budgetHead: 'In stock within your budget',
    matchHead: 'In stock now',
    similarHead: 'Similar products in stock',
    altHead: 'Sold out – in-stock alternatives',
    bundleHead: 'Combinations within your budget',
    none: 'No in-stock matches for that. Try a product type:',
    seeAll: 'See all results',
    add: 'Add to cart', added: 'Added ✓', options: 'Choose options', viewCart: 'View cart',
    aiNote: 'Interpreted with AI',
    stale: 'Prices could not be re-checked just now – please confirm on the product page.',
    age: 'Adults only: our products are for customers aged 18 or over.',
    from: 'from', total: 'Total', sold: 'currently sold out'
  };
  for (var ck in (cfg.copy || {})) copy[ck] = cfg.copy[ck];

  var state = { engine: null, loading: null, seq: 0, panel: null, input: null, aiStatus: null, aiStatusAt: 0, liveCache: {}, logged: {}, lastQuery: '' };

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'text') el.textContent = attrs[k]; else if (attrs[k] !== null && attrs[k] !== undefined) el.setAttribute(k, attrs[k]); }
    (kids || []).forEach(function (c) { if (c) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  function money(p) { return POUND + (p / 100).toFixed(2); }
  function priceLabel(it) { return it.priceMin === it.priceMax ? money(it.priceMin) : copy.from + ' ' + money(it.priceMin); }
  function imgUrl(path, w) {
    if (!path) return '';
    if (/^\/\//.test(path)) path = 'https:' + path;                    // protocol-relative URL from the feed
    if (/^https?:/.test(path) && /[?&]width=/.test(path)) return path;  // already sized by the feed
    var full = /^https?:/.test(path) ? path : 'https://cdn.shopify.com/s/files/' + path;
    return full.replace(/(\.[a-z0-9]+)(\?|$)/i, '_' + w + 'x$1$2');
  }
  function productUrl(handle) { return '/products/' + encodeURIComponent(handle); }
  function searchUrl(q) { return '/search?type=product&q=' + encodeURIComponent(q) + '&jsai=1'; }  // jsai=1: the AI Shopper results page

  // ---- catalogue: Shopify renders it for us (templates/collection.js-ai-feed.liquid), so it is always
  // the live catalogue in the shopper's market. It is cached in the browser for 6 hours (7 days as a
  // stand-by while a refresh runs). cfg.catalogueUrl can point at a single static file instead.
  var CACHE_KEY = 'jsai-cat-v1-' + (cfg.market || '');
  var FRESH_MS = 6 * 3600 * 1000, STALE_MS = 7 * 24 * 3600 * 1000;
  function cacheRead() { try { var c = JSON.parse(localStorage.getItem(CACHE_KEY)); return c && c.p && c.p.length ? c : null; } catch (e) { return null; } }
  function cacheWrite(p) { try { localStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), p: p })); } catch (e) { /* quota or private mode: fine */ } }
  function getJson(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.text(); }).then(function (t) { return JSON.parse(t); }); }

  function fetchFeed() {
    var base = cfg.feedUrl + (cfg.feedUrl.indexOf('?') < 0 ? '?' : '&') + 'page=';
    return getJson(base + 1).then(function (first) {
      var pages = Math.min(Number(first.pages) || 1, 40), all = first.p.slice(), next = 2;
      function worker() {
        if (next > pages) return Promise.resolve();
        var n = next++;
        return getJson(base + n).then(function (d) { all = all.concat(d.p); }).then(worker);
      }
      var workers = []; for (var i = 0; i < Math.min(5, pages - 1); i++) workers.push(worker());
      return Promise.all(workers).then(function () {
        var seen = {}, out = [];
        all.forEach(function (rec) { if (!seen[rec.i]) { seen[rec.i] = true; out.push(rec); } });
        return out;
      });
    });
  }

  function getCatalogue() {
    if (cfg.catalogueUrl) return getJson(cfg.catalogueUrl).then(function (d) { return d.p; });
    var cached = cacheRead(), age = cached ? Date.now() - cached.at : Infinity;
    if (cached && age < FRESH_MS) return Promise.resolve(cached.p);
    var fresh = fetchFeed().then(function (p) { if (p.length) cacheWrite(p); return p; });
    if (cached && age < STALE_MS) { fresh.catch(function () {}); return Promise.resolve(cached.p); }
    return fresh;
  }

  function loadEngine() {
    if (state.engine) return Promise.resolve(state.engine);
    if (state.loading) return state.loading;
    var conf = cfg.configUrl ? getJson(cfg.configUrl) : Promise.resolve({});
    state.loading = Promise.all([conf, getCatalogue()]).then(function (res) {
      state.engine = new Engine({ p: res[1], syn: res[0].syn || [], k: res[0].k, generated: new Date().toISOString() });
      return state.engine;
    });
    state.loading.catch(function () { state.loading = null; });
    return state.loading;
  }

  function fetchLive(handle) {
    var hit = state.liveCache[handle];
    if (hit && Date.now() - hit.at < 60000) return Promise.resolve(hit.data);
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 3000);
    return fetch(productUrl(handle) + '.js', { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('live ' + r.status); return r.json(); })
      .then(function (data) { clearTimeout(timer); state.liveCache[handle] = { at: Date.now(), data: data }; return data; })
      .catch(function () { clearTimeout(timer); return null; });
  }

  /** Verify items live. Returns {items, unverified}. Sold-out or out-of-budget products are dropped. */
  function verifyItems(items, budget, want) {
    var pool = items.slice(0, want + 4), unverified = false;
    return Promise.all(pool.map(function (it) { return fetchLive(it.handle); })).then(function (lives) {
      var out = [];
      pool.forEach(function (it, i) {
        var live = lives[i];
        if (!live) { unverified = true; out.push(it); return; }
        var upd = applyLive(it, live, budget);
        if (upd) out.push(upd);
      });
      return { items: out.slice(0, want), unverified: unverified };
    });
  }

  function verifyBundles(bundles, budget) {
    var handles = {}, list = [];
    bundles.forEach(function (b) { b.items.forEach(function (it) { if (!handles[it.handle]) { handles[it.handle] = true; list.push(it.handle); } }); });
    return Promise.all(list.map(fetchLive)).then(function (lives) {
      var liveBy = {}, unverified = false;
      list.forEach(function (hd, i) { liveBy[hd] = lives[i]; if (!lives[i]) unverified = true; });
      var out = [];
      bundles.forEach(function (b) {
        var items = [], ok = true;
        b.items.forEach(function (it) {
          var live = liveBy[it.handle];
          var upd = live ? applyLive(it, live, null) : it;
          if (!upd) ok = false; else items.push(upd);
        });
        if (!ok) return;
        var total = items.reduce(function (s, it) { return s + it.priceMin; }, 0);
        if (budget.max !== null && total > budget.max) return;
        out.push({ items: items, total: total });
      });
      return { bundles: out, unverified: unverified };
    });
  }

  // ---------------------------------------------------------------- AI interpreter (optional)
  function aiAvailable() {
    if (!cfg.apiBase) return Promise.resolve(false);
    if (state.aiStatus !== null && Date.now() - state.aiStatusAt < 300000) return Promise.resolve(state.aiStatus);
    return timeoutFetch(cfg.apiBase + '/api/status', { credentials: 'omit' }, 2000).then(function (r) { return r.json(); })
      .then(function (d) { state.aiStatus = !!d.ai; state.aiStatusAt = Date.now(); return state.aiStatus; })
      .catch(function () { state.aiStatus = false; state.aiStatusAt = Date.now(); return false; });
  }
  function timeoutFetch(url, opts, ms) {
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, ms);
    if (ctl) opts.signal = ctl.signal;
    return fetch(url, opts).then(function (r) { clearTimeout(t); return r; }, function (e) { clearTimeout(t); throw e; });
  }
  function interpret(q) {
    return timeoutFetch(cfg.apiBase + '/api/interpret', { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ q: q }) }, 4500)
      .then(function (r) { return r.json(); })
      .then(function (d) { return d && (d.status === 'used' || d.status === 'cached') && d.intent ? { intent: d.intent, ai: d.status } : { ai: (d && d.status) || 'error' }; })
      .catch(function () { return { ai: 'error' }; });
  }

  // ---------------------------------------------------------------- anonymous log (optional)
  function logSearch(q, reply, aiState, conv) {
    if (!cfg.apiBase || state.logged[q]) return;
    state.logged[q] = true;
    var types = {}, shown = reply.items.length, order = [];
    reply.items.concat(reply.alternatives).forEach(function (it) { if (it.type && !types[it.type]) { types[it.type] = 1; order.push(it.type); } });
    var body = JSON.stringify({ q: q, conv: conv, shown: shown, alt: reply.alternatives.length, bundles: reply.bundles.length,
      soldout: !shown && !reply.bundles.length && reply.alternatives.length > 0, ai: aiState,
      bmin: reply.budgetMin === null ? null : reply.budgetMin / 100, bmax: reply.budgetMax === null ? null : reply.budgetMax / 100, types: order.slice(0, 3) });
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(cfg.apiBase + '/api/log', new Blob([body], { type: 'text/plain' }));
      else fetch(cfg.apiBase + '/api/log', { method: 'POST', body: body, keepalive: true, credentials: 'omit' });
    } catch (e) { /* analytics must never affect shopping */ }
  }

  X.ui = { cfg: cfg, copy: copy, state: state, h: h, money: money, priceLabel: priceLabel, imgUrl: imgUrl, productUrl: productUrl, searchUrl: searchUrl,
    loadEngine: loadEngine, verifyItems: verifyItems, verifyBundles: verifyBundles, aiAvailable: aiAvailable, interpret: interpret, logSearch: logSearch };
})(window);